import { Component, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-simple-message-modal',
  templateUrl: './simple-message-modal.component.html',
  styleUrls: ['./simple-message-modal.component.css']
})
export class SimpleMessageModalComponent implements OnDestroy {

  @Input() headerText = '';
  @Input() messageText: string;
  @Input() messageAlertClass: string;
  // An optional second alert shown beneath the main message (e.g. an extra
  // informational note). No second alert is rendered when this is unset.
  @Input() secondaryMessageText: string = null;
  @Input() secondaryMessageAlertClass = 'alert-info';
  @Input() hasConfirmation = false;
  @Input() confirmedCallback: () => undefined = null;
  // A function which is called when the modal is closed (including due to
  // confirmation, in which case it will be called after confirmedCallback).
  @Input() closedCallback: () => undefined = null;

  // Set once the user clicks Confirm. Guards against a double-submit (fast
  // double click or a duplicate touch event landing on the button while the
  // modal fades out) firing confirmedCallback twice, which previously recorded
  // duplicate offline payments (PRO-1285). Also drives the button's loading
  // state in the template.
  public confirming = false;

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  public handleConfirm() {
    if (this.confirming) {
      return;
    }
    this.confirming = true;

    // Dismiss in a finally so a callback that throws synchronously can't
    // leave the modal open with a permanently disabled Confirm button.
    try {
      if (this.confirmedCallback !== null) {
        this.confirmedCallback();
      }
    } finally {
      this.activeModal.dismiss();
    }
  }

  public ngOnDestroy() {
    if (this.closedCallback !== null) {
      this.closedCallback();
    }
  }

}
